import { memberBenefits } from '@/mocks/homeData';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 dark:text-foreground-950 mb-4">
              加入九州体育会员
            </h2>
            <p className="text-background-100 dark:text-foreground-800 text-base max-w-[550px] mx-auto leading-relaxed">
              注册即享高清直播、专属赔率、VIP客服等多项特权，开启你的极致体育体验
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 mb-10">
            {memberBenefits.map((benefit) => (
              <div key={benefit.title} className="text-center p-5 bg-background-50/10 backdrop-blur-sm rounded-xl border border-background-50/15">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/15 text-background-50 dark:text-foreground-950">
                  <i className={`${benefit.icon} text-xl`}></i>
                </div>
                <h3 className="text-sm font-semibold text-background-50 dark:text-foreground-950 mb-1">{benefit.title}</h3>
                <p className="text-xs text-background-200 dark:text-foreground-800 leading-relaxed">{benefit.desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a
              href="#"
              className="inline-flex items-center gap-2 px-10 py-4 bg-background-50 text-primary-500 rounded-xl text-base font-bold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即注册 <i className="ri-arrow-right-line"></i>
            </a>
            <p className="mt-3 text-xs text-background-200 dark:text-foreground-800">已有账号？<a href="#" className="underline hover:text-background-50 dark:hover:text-foreground-950 cursor-pointer">立即登录</a></p>
          </div>
        </div>
      </div>
    </section>
  );
}